import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { User, ChevronRight } from "react-feather";

const AdminTopbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const adminId = localStorage.getItem("admin_id");
    if (!adminId) {
      navigate("/admin/login");
    } else if (adminId === "1") {
      setIsAdmin(true);
    }
  }, [navigate]);

  const getBreadcrumbLabel = (path) => {
    switch (path) {
      case "/admin/dashbaord": return "Admin Dashboard";
      case "/admin/category": return "Category";
      case "/admin/sub-category": return "Sub Category";
      case "/admin/brand": return "Brand";
      case "/admin/seller-report": return "Seller Report";
      case "/admin/customer-report": return "Customer Report";
      case "/admin/admin-booking": return "All Bookings";
      case "/admin/all-staff": return "All Staff /Employee";
      case "/admin/admin-booking-report": return "Booking Report";
      case "/admin/admin-change-password": return "Change Password";
      default: return "Dashboard";
    }
  };

  const currentLabel = getBreadcrumbLabel(location.pathname);

  return (
    <>
      <div className="bg-white sticky-top topbar1">
        <div className="row align-items-center">
          <div className="col-6"></div>
          <div className="col-6">
            <ul className="d-flex justify-content-end align-items-center mb-0 list-unstyled">
              
              {/* Conditional Admin Links - Only shows if admin_id is 1 */}
              {isAdmin && (
                <>
                  <li className="mx-2">
                    <a href="https://techsparesindia.com/email/product_excel.html" target="_blank" rel="noopener noreferrer" className="topbar-tool-link">
                      Excel Tool
                    </a>
                  </li>
                  <li className="mx-2">
                    <a href="https://techsparesindia.com/email/email-tool.html" target="_blank" rel="noopener noreferrer" className="topbar-tool-link">
                      Email Tool
                    </a>
                  </li>
                </>
              )}

              <li className="mx-2 op2">
                <Link to="/admin/profile" className="op1 text-decoration-none">
                  <User size={16} />
                  &nbsp;Hello Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="px-2 text-start brdcrm1 my-2">
        <span className="brdcrm1">Dashboard</span>
        <span>&nbsp;<ChevronRight size={15} />&nbsp;</span>
        <span className="brdcrm1">{currentLabel}</span>
      </div>


<style>
  {`
  /* Style for the new external tool links */
.topbar-tool-link {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-decoration: none;
  padding: 4px 8px;
  background: #f0f0f0;
  border-radius: 4px;
  transition: background 0.2s;
}

.topbar-tool-link:hover {
  background: #e0e0e0;
  color: #000;
}

/* Ensure the list in your topbar doesn't have default bullets */
.topbar1 ul {
  list-style: none;
  margin: 0;
  padding: 0;
}`}
</style>

    </>
  );
};

export default AdminTopbar;